export class RateDeleteBody {
    rateIds: number[];
  }
  